import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Words = ({
  text,
  mode = "scroll",
  delay = 0,
  stagger = 0.05,
  className = "",
  as: Tag = "span",
}) => {
  const words = String(text).split(" ");
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.9, ease: EASE } },
  };
  return (
    <Tag className={className} aria-label={text}>
      <motion.span
        className="inline"
        variants={container}
        {...(mode === "load"
          ? { initial: "hidden", animate: "show" }
          : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } })}
      >
        {words.map((w, i) => (
          <React.Fragment key={i}>
            <span
              aria-hidden="true"
              className="inline-flex overflow-hidden align-baseline"
              style={{ paddingBlock: "0.18em", marginBlock: "-0.18em" }}
            >
              <motion.span className="inline-block will-change-transform" variants={child}>
                {w}
              </motion.span>
            </span>
            {i < words.length - 1 ? " " : ""}
          </React.Fragment>
        ))}
      </motion.span>
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, y = 18, className = "", amount = 0.15, mode = "scroll" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    {...(mode === "load"
      ? { animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, ease: EASE, delay } }
      : { whileInView: { opacity: 1, y: 0 }, viewport: { once: true, amount }, transition: { duration: 0.8, ease: EASE, delay } })}
  >
    {children}
  </motion.div>
);

export const PopIn = ({ children, delay = 0, className = "", amount = 0.15 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.7, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
